import { render, staticRenderFns } from "./CoTwoTransportForm.vue?vue&type=template&id=79a81f51&scoped=true&"
import script from "./CoTwoTransportForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoTransportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a81f51",
  null
  
)

export default component.exports